import { ControllerFlowAPI } from '@wix/yoshi-flow-editor';
import { isUserJoinedAlreadyWithoutSuspended } from '../../../contexts/User/helpers/userTypeHandlers';
import { getParticipantState } from '../../../selectors/participant/getState';
import { isParticipantPageAvailable } from '../../../contexts/Location/helpers/generateLinksToProgramForList';
import { isLoggedInUser } from '../../../contexts/User/helpers/userContextHelpers';

export async function needToRedirectToParticipantPage({
  initialProps,
  flowAPI,
}: {
  initialProps: any;
  flowAPI: ControllerFlowAPI;
}) {
  if (!isLoggedInUser(flowAPI) || !flowAPI.environment.isViewer) {
    return false;
  }

  const participant = initialProps?.participant;

  if (
    participant &&
    isUserJoinedAlreadyWithoutSuspended(getParticipantState(participant)) &&
    (await isParticipantPageAvailable(flowAPI))
  ) {
    return true;
  }

  return false;
}
